import styled from 'styled-components';



export const BaseFiltroAvancadoItemStyleH1 = styled.div`

  .h3-style {
    color: ${(props) => (props.theme.primary)} !important;
    color: #ffffff;
  }
`;
